import React from 'react'
import styles from './styles'
import Typography from "@material-ui/core/Typography"
import {sliderContent} from "./sliderContent"
import { LinkSlide, Slider } from "~/components/ui"
import { useMediaQuery, useTheme } from "@material-ui/core"

export const SliderExpertise = () => {
  const classes = styles();
  const theme = useTheme();
  const isPhone = useMediaQuery(theme.breakpoints.down('xs'));
  const items = sliderContent.map((item) => <LinkSlide {...item}/>);
  return (
    <div>
      <div className={classes.titleBlock}>
        <Typography variant={isPhone ? 'h4' : 'h3'} className={classes.title}>Our Process</Typography>
      </div>
      <div className={classes.slider}>
        <Slider
          centered
          firstItemIndex={0}
          items={items}
        />
      </div>
    </div>
  );
};
